import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { BookmarkParentType } from '~/apollo/generated/v4/graphql';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOItemListV4 } from '~/components/supporting-object/so-item-list-v4';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const STUDY_FACIES_PAGE = graphql(`
  query StudyFaciesPage($id: ID!) {
    studyGet(id: $id) {
      id
      facies {
        ...faciesParts
        pictures {
          ...soPictureParts
        }
      }
    }
  }
`);

export default function StudyFaciesPage() {
  return (
    <ApolloProviderV4>
      <StudyFaciesPageInner />
    </ApolloProviderV4>
  );
}

function StudyFaciesPageInner() {
  const studyId = useRouteParam('studyId', parseInt);

  const { data, loading } = useQuery(STUDY_FACIES_PAGE, {
    variables: { id: studyId },
  });

  const refetchQueries = createRefetchQueries([
    { query: STUDY_FACIES_PAGE, variables: { id: studyId } },
  ]);

  const facies = data?.studyGet?.facies ?? [];

  if (loading) return <SpinnerPlaceholder />;

  return (
    <SOItemListV4
      items={facies}
      soParentType="study"
      soParentId={studyId}
      bookmarkParentType={BookmarkParentType.Facies}
      refetchQueries={refetchQueries}
    />
  );
}
